import { useState } from "react";
import { motion } from "framer-motion";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { toggleTheme } from "@/utils/theme";
import { message, Button } from 'antd';
import "@/components/css/navbar.css"
import statics from "@/utils/statics.json";

export const Navbar = () => {
    const [currentTheme, setCurrentTheme] = useState(localStorage.getItem("theme") || "light");
    const [messageApi, contextHolder] = message.useMessage();

    const handleToggleTheme = () => {
        toggleTheme(setCurrentTheme);
    };

    const handleCvDownload = () => {
        if (0) {
            window.open("/assets/pdf/example-cv.pdf", "_blank")
        } else {
            messageApi.open({
                type: 'info',
                content: "cv'm henüz hazır değil",
            });
        }
    }

    return (
        <nav style={{
            display: 'flex',
            width: '100%',
            backgroundColor: 'var(--color-bg-secondary)',
            color: 'var(--color-text)',
            justifyContent: 'center',
        }}>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    maxWidth: '1300px'
                }}
            >
                <a href="/">
                    <img
                        style={{
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: '10px',
                        }}
                        src="../assets/pictures/my-profile3.jpg"
                        alt=""
                    />
                </a>

                <div style={{ marginRight: 'auto' }}>
                    <p>{statics.myName}</p>
                    <p>{t("my-job")}</p>
                </div>
                <div
                    className="nav-right"
                    style={{
                        display: 'flex',
                        gap: '10px',
                    }}
                >
                    {contextHolder}
                    <Button
                        className="btn-cv"
                        type="primary"
                        style={{
                        }}
                        onClick={handleCvDownload} >{t("cv-download")}</Button>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '10px'
                        }}
                    >
                        <Button
                            className="btn-theme"
                            style={{
                                backgroundColor: '#3f51b5',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px'
                            }}
                            onClick={handleToggleTheme}>
                            {currentTheme === "dark" ? "🌙" : "☀️"}
                        </Button>
                        <TranslateToggle />
                    </div>
                </div>
            </div>
        </nav >
    );
};

export default Navbar;

const TranslateToggle: React.FC = () => {
    const { i18n } = useTranslation();
    const selected = i18n.language.startsWith("tr") ? "TR" : "EN";

    const changeLanguage = (lng: "tr" | "en") => {
        i18n.changeLanguage(lng);
    };

    const handleToggle = () => {
        if (selected === "TR") {
            changeLanguage("en");
        } else {
            changeLanguage("tr");
        }
    };

    return (
        <div
            onClick={handleToggle}
            className="btn-language"
            style={{
                position: "relative",
                width: 80,
                height: 40,
                backgroundColor: "#dededeff",
                borderRadius: 5,
                display: "flex",
                cursor: "pointer",
                userSelect: "none",
                fontWeight: 600,
                color: "#444",
            }}
        >
            <motion.div
                layout
                initial={false}
                animate={{ x: selected === "TR" ? 0 : 40 }}
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 40,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#007bff",
                    zIndex: 0,
                }}
            />

            <button
                style={{
                    flex: 1,
                    border: "none",
                    background: "transparent",
                    zIndex: 1,
                    color: selected === "TR" ? "white" : "#444",
                    borderRadius: 5,
                    outline: "none",
                    cursor: "pointer",
                }}
            >
                {t("lang-tr")}
            </button>
            <button
                style={{
                    flex: 1,
                    border: "none",
                    background: "transparent",
                    zIndex: 1,
                    color: selected === "EN" ? "white" : "#444",
                    borderRadius: 5,
                    outline: "none",
                    cursor: "pointer",
                }}
            >
                {t("lang-en")}
            </button>
        </div>
    );
};

